function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgIconCheck = function SvgIconCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4707 0.544098C19.2749 1.08021 19.4922 2.16674 18.9561 2.97091L9.62273 16.9709C9.33191 17.4071 8.86082 17.69 8.33909 17.7417C7.81735 17.7933 7.29994 17.6083 6.92921 17.2376L1.09588 11.4043C0.412459 10.7209 0.412459 9.61283 1.09588 8.92941C1.77929 8.246 2.88733 8.246 3.57075 8.92941L7.89465 13.2533L16.0439 1.02946C16.58 0.225285 17.6665 0.00798117 18.4707 0.544098Z",
    fill: "white"
  }));
};
export default SvgIconCheck;